export const view = {
    methods: {
        selectMenuCategory: function (e) {
            var _self = this;
            var option = e.target.closest('div.menu-category');
            var categoryID = option.getAttribute('data-id');
            var menuCategories = e.target.closest('.menu-container').querySelectorAll('.product-category');
            var menuItems = e.target.closest('.menu-container').querySelectorAll('.menuItem');
            e.target.closest('.menu-categories').querySelectorAll('.menu-category').forEach((item) => {
                if (item.classList.contains('active-category')) {
                    item.removeAttribute('style');
                    item.querySelectorAll('i').forEach((subItem) => {
                        subItem.removeAttribute('style');
                    });
                }
            });
            _self.resizeCategories();

            if (option.classList.contains('active-category')) {
                option.classList.remove('active-category');

                // filtering remove if not needed
                menuCategories.forEach(item => { item.style.display = 'block'; });
                menuItems.forEach(item => { item.style.display = 'inline-grid'; });
                // end filtering
            } else {
                // If single select, remove if multi select
                var activeCategory = document.querySelector('#menu-categories .menu-category.active-category');
                if (activeCategory != null)
                    activeCategory.classList.remove('active-category');
                // end if

                option.classList.add('active-category');

                // filtering remove if not needed
                menuCategories.forEach(item => {
                    item.style.display = 'none';
                    var menuItemCategoryID = item.getAttribute('data-category-id');
                    if (menuItemCategoryID != undefined && menuItemCategoryID != '' && menuItemCategoryID == categoryID) {
                        item.style.display = 'block';
                    }
                });

                menuItems.forEach(item => {
                    item.style.display = 'none';
                    var menuItemCategoryID = item.getAttribute('data-category-id');
                    if (menuItemCategoryID != undefined && menuItemCategoryID != '' && menuItemCategoryID == categoryID) {
                        item.style.display = 'inline-grid';
                    }
                });
                // end filtering
            }
        },
        resizeCategories: function () {
            var categories = document.getElementsByClassName('menu-category');
            var widths = [];
            for (var i = 0;i < categories.length;i++) {
                widths.push(getComputedStyle(categories[i]).width.slice(0, -2));
            }
            var maxWidth = Math.max.apply(Math, widths);
            for (var ic = 0;ic < categories.length;ic++) {
                categories[ic].style.width = maxWidth + 'px';
            }
        },
        selectItem: function (e) {
            var _self = this;
            var id = e.target.closest('.menuItem').getAttribute('data-id')

            var data = {
                FranchiseID: localStorage.franchiseID,
                ID: id
            }
            _self.$ooApi.orders.menu.items.get.v1(data).then(function (result) {
                _self.$refs.menuItemModal.openModal(id);
                _self.$refs.menuItemModal.populate(result.data);
            }).then(function () {
                if (document.querySelector('.menuItem_title') != null) {
                    var menuItem_title_height = document.querySelector('.menuItem_title').offsetHeight;
                    document.querySelector('.modifiersContainer').style.paddingTop = menuItem_title_height + 'px';
                }
                _self.addEventListener('.menuItem_total .updateQuantity', 'click', _self.updateQuantity);
                _self.addEventListener('.menuItem_total input#number', 'change', _self.updateItemQuantity);
                _self.addEventListener('.modifiersContainer .menuItem_add', 'click', _self.addToCart);
                _self.addEventListener('.modifiersContainer input[name=special-instructions]', 'focus', _self.focusOnInstructions);
                _self.addEventListener('.modifiersContainer .menuItem_checkout', 'click', _self.checkout);
                _self.addEventListener('.modifiersContainer .menuItem_options', 'mouseover', function (e) {
                    var target = e.currentTarget;
                    target.style.backgroundColor = _self.accentColor;
                    target.style.color = '#fff';
                    target.style.cursor = 'pointer';
                });
                _self.addEventListener('.modifiersContainer .menuItem_options', 'mouseout', function (e) {
                    var target = e.currentTarget;
                    if (!target.classList.contains('active_menuItem_option')) {
                        target.style.backgroundColor = '#e8e8e8';
                        target.style.color = '#8a8a8a';
                    }
                });
                _self.addEventListener('.modifiersContainer .menuItem_options', 'click', function (e) {
                    var target = e.currentTarget;
                    if (target.classList.contains('active_menuItem_option')) {
                        target.style.backgroundColor = '#e8e8e8';
                        target.style.color = '#8a8a8a';
                    }
                    else {
                        target.style.backgroundColor = _self.accentColor;
                        target.style.color = '#fff';
                    }
                    _self.selectOption(e);

                    target.closest('.modifiersContainer').querySelectorAll('.menuItem_options:not(.active_menuItem_option)').forEach(item => {
                        item.style.backgroundColor = '#e8e8e8';
                        item.style.color = '#8a8a8a';
                    });
                });
            });

        },
        addEventListener(query, eventType, fnc) {
            var elements = document.querySelectorAll(query);
            if (elements != null && elements.length > 0)
                elements.forEach(item => {
                    item.addEventListener(eventType, fnc);
                });
        },

        updateQuantity: function (e) {
            var _self = this;
            var diff = e.target.closest('.updateQuantity').getAttribute('data-diff');
            var input = e.target.closest('form').querySelector('input');
            var updatedVal = _self.tryParseInt(input.value) + _self.tryParseInt(diff);

            input.value = updatedVal < 0 ? 0 : updatedVal;
        },

        /* Menu Item Form */

        // Update Quantity
        updateItemQuantity: function (e) {
            var _self = this;
            if (_self.tryParseInt(e.target.value, 1) < 1) {
                e.target.value = 1;
            }
            updatePrice(_self);
        },

        // Select an menu item option
        selectOption: function (e) {
            var _self = this;
            var option = e.target.closest('.menuItem_options');
            var parent = e.target.closest('.menuItem_question');
            var max = _self.tryParseInt(parent.getAttribute('data-max'), 1);
            var menuItems = parent.querySelectorAll('.menuItem_options');

            if (max == 1 || max == 0) {
                if (option.classList.contains('active_menuItem_option')) {
                    option.classList.remove('active_menuItem_option');
                } else {
                    menuItems.forEach(item => { item.classList.remove('active_menuItem_option'); });
                    option.classList.add('active_menuItem_option');
                }
            } else {
                if (option.classList.contains('active_menuItem_option')) {
                    option.classList.remove('active_menuItem_option');
                } else {
                    if (parent.querySelectorAll('.active_menuItem_option').length < max)
                        option.classList.add('active_menuItem_option');
                    else
                        _self.showToaster('Oops', 'The maximum amount of options have been selected.', 'danger');
                }
            }
            updatePrice(_self);
        },

        // Add to cart
        addToCart: function () {
            var _self = this;
            var parameters = getOrderModel(_self);
            if (parameters != null)
                _self.$ooApi.orders.cart.add.v1(parameters).then(function (response) {
                    if (response.success) {
                        localStorage.cartGuid = response.data.guid;
                        _self.refreshCart();
                    } else
                        console.log(response.message);
                }).then(function () {
                    _self.$refs.menuItemModal.closeModal();
                })
            // check .catch
        },

        // Focus on 
        focusOnInstructions: function (e) {
            var image = e.target.closest('div.modal__dialog').querySelector('.modal__header');
            var panel = e.target.closest('.modal__body');

            var dialog = image.closest('.modal__dialog');
            if (dialog.classList.contains('no-image') === false)
                image.style.display = 'none';

            panel.classList.add('instructions-focus');
        },

        // Go to checkout
        checkout: function () {
            var _self = this;
            var parameters = {
                Guid: localStorage.cartGuid,
                FranchiseID: localStorage.franchiseID
            };
            _self.$ooApi.orders.cart.eligible.v1(parameters).then(function (response) {
                if (response.success) {
                    _self.$router.push('Checkout');
                } else {
                    if (response.message == 'No user logged in.')
                        _self.$router.push({ path: 'Login', query: { returnUrl: window.location.pathname } });
                }
            })
            // check .catch
        }
    }
}

function getOrderModel(_self) {
    // Get array of selected modifier choices
    var orderOptions = document.querySelectorAll('.modifiersContainer .menuItem_question');
    var modifiers = [];
    orderOptions.forEach(item => {
        var selectedOptionsArray = [];
        var min = _self.tryParseInt(item.getAttribute('data-min'), 0);
        var selectedOptions = item.querySelectorAll('.active_menuItem_option');

        if (selectedOptions.length < min) {
            _self.showToaster('Oops', 'The minimum amount of options have not been selected. Please "' + item.querySelectorAll('h4')[0].innerText + '"', 'danger');
            return false;
        }

        selectedOptions.forEach(item => {
            selectedOptionsArray.push({
                ID: item.getAttribute('data-id')
            });
        });
        modifiers.push({
            ID: item.getAttribute('data-id'),
            Choices: selectedOptionsArray
        });
    });

    if (orderOptions.length > modifiers.length)
        return null;

    var model = {
        FranchiseID: localStorage.franchiseID,
        Guid: localStorage.cartGuid,
        ProductID: document.querySelectorAll('.modifiersContainer')[0].getAttribute('data-productid'),
        Quantity: document.querySelectorAll('.menuItem_total form input')[0].value,
        Modifiers: modifiers,
        SpecialInstructions: document.querySelectorAll('.modifiersContainer input[name=special-instructions]')[0].value
    }

    return model;
}

function calculatePrice(_self) {
    // Add product price
    var productPrice = _self.tryParseFloat(document.querySelectorAll('span.total-price')[0].getAttribute('data-price'), 0);
    var orderOptions = document.querySelectorAll('.modifiersContainer .menuItem_question');

    // Add selected modifiers prices
    var modifiersPrice = 0;
    orderOptions.forEach(item => {
        var selectedOptions = item.querySelectorAll('.active_menuItem_option');
        var inclusive = _self.tryParseInt(item.getAttribute('data-inclusive'));

        var prices = [];
        selectedOptions.forEach(option => {
            prices.push(_self.tryParseFloat(option.closest('.menuItem_options').querySelectorAll('span.modifier-price')[0]?.innerHTML, 0))
        });
        _self.sortNumbersInArrayAsc(prices);
        prices.splice(0, inclusive);

        modifiersPrice += prices.reduce(function (a, b) {
            return a + b;
        }, 0);
    });

    var quantity = _self.tryParseFloat(document.querySelectorAll('.menuItem_total input#number')[0].value, 1)
    productPrice = productPrice * quantity;
    modifiersPrice = modifiersPrice * quantity;

    return {
        ProductPrice: productPrice.toFixed(2),
        ModifiersPrice: modifiersPrice.toFixed(2),
        TotalPrice: (productPrice + modifiersPrice).toFixed(2)
    };
}

function updatePrice(_self) {
    var price = calculatePrice(_self);

    document.querySelector('.menuItem_total .total-modifiers-price').innerHTML = price.ModifiersPrice;
    document.querySelector('.menuItem_total .total-price').innerHTML = price.TotalPrice;
}